import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DatePicker from 'react-datepicker';
import { NumericFormat } from 'react-number-format';
import { RentalExpenseTypeOptions } from '../LoanConstants';

export const RentalExpenseEntryDialog = ({ entry, onSubmit, onCancel }) => {
    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
    };

    const [amount, set_amount] = useState(null);
    const [yearEnd, set_yearEnd] = useState(null);
    const [expenseOption, set_expenseOption] = useState(null);

    useEffect(() => {
        if (!entry) {
            resetState();
            return;
        }
        set_amount(entry.amount);
        const sd = entry.yearEnd ? new Date(entry.yearEnd) : entry.minDate ? new Date(entry.minDate) : null;
        set_yearEnd(sd);

        const option = RentalExpenseTypeOptions.find((et) => et.id === entry.expenseTypeId);
        set_expenseOption(option);
    }, [entry]);

    const resetState = () => {
        set_amount(null);
        set_yearEnd(null);
    };

    const _onCancel = () => {
        onCancel && onCancel();
    };

    const _onSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const model = {
            id: entry.id,
            expenseGuid: entry.expenseGuid,
            guid: entry.guid,
            amount,
            yearEnd,
        };

        onSubmit && onSubmit(model);
    };

    const setAmount = (value) => {
        set_amount(value);
    };

    const setYearEnd = (value) => {
        if (value) {
            const dt = new Date(value);
            set_yearEnd(dt);
        }
    };

    if (!entry || !expenseOption) {
        return '';
    }

    return (
        <Dialog
            maxWidth='sm'
            open={true}
            onClose={_onCancel}
            aria-labelledby='form-dialog-title'
        >
            <DialogContent>
                <div className='modal-container'>
                    <div className='modal-backdrop'></div>
                    <div
                        className='modal'
                        tabIndex={-1}
                        role='dialog'
                        style={{ width: '450px' }}
                    >
                        <div
                            className='modal-dialog'
                            role='document'
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1 style={{ whiteSpace: 'nowrap' }}>{expenseOption.name}</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={_onCancel}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                        </div>

                        <form
                            name='expenseEntryForm'
                            onSubmit={(event) => _onSubmit(event)}
                        >
                            <div
                                className='standard-form no-search'
                                style={{
                                    padding: '0',
                                    margin: '10px 0px',
                                    height: '300px',
                                }}
                            >
                                <div style={{ padding: '0px 7px' }}>
                                    <div
                                        className='row'
                                        style={styles.formRow}
                                    >
                                        <div className='columns small-12 large-5'>
                                            <label htmlFor={'amount'}>
                                                Amount <span className='req'>*</span>
                                            </label>
                                            {expenseOption.isAnnual && (
                                                <NumericFormat
                                                    thousandSeparator=','
                                                    prefix='$'
                                                    id={'amount'}
                                                    name={'amount'}
                                                    placeholder='$'
                                                    value={amount}
                                                    decimalScale={2}
                                                    allowNegative={false}
                                                    displayType='input'
                                                    required={true}
                                                    onValueChange={(values) => {
                                                        setAmount(values.floatValue);
                                                    }}
                                                    isAllowed={(values, sourceInfo) => {
                                                        const value = values?.floatValue;
                                                        return value === undefined || value === null || value > 0;
                                                    }}
                                                />
                                            )}

                                            {!expenseOption.isAnnual && (
                                                <NumericFormat
                                                    thousandSeparator=','
                                                    suffix={'%'}
                                                    id={'amount'}
                                                    name={'amount'}
                                                    placeholder='%'
                                                    value={amount}
                                                    decimalScale={2}
                                                    allowNegative={false}
                                                    displayType='input'
                                                    required={true}
                                                    onValueChange={(values) => {
                                                        setAmount(values.floatValue);
                                                    }}
                                                    isAllowed={(values, sourceInfo) => {
                                                        const value = values?.floatValue;
                                                        return value === undefined || value === null || value > 0;
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {expenseOption.isAnnual && (
                                            <div className='columns small-12 large-5'>
                                                <label htmlFor={'yearEnd'}>
                                                    Year End <span className='req'>*</span>
                                                </label>
                                                <DatePicker
                                                    id={'yearEnd'}
                                                    selected={yearEnd}
                                                    onChange={(value) => setYearEnd(value)}
                                                    required={true}
                                                    showYearDropdown
                                                    minDate={entry.minDate}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div
                                className='button-footer'
                                style={styles.buttonContainer}
                            >
                                <button
                                    style={styles.buttonMarginRight}
                                    type='submit'
                                    className='button primary'
                                >
                                    Update
                                </button>
                                <button
                                    type='button'
                                    className='button hollow'
                                    data-dismiss='modal'
                                    onClick={_onCancel}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
